import type { AnyRoute } from "@tanstack/react-router";
import type { LucideIcon } from "lucide-react";

export type NavGroup =
  | "Overview"
  | "Revenue"
  | "Finance"
  | "Operations"
  | "Monitors"
  | "Strategy"
  | "Tools"
  | "System";

/** Render order of groups in the sidebar. Unmatched features fall under "Other". */
export const NAV_GROUP_ORDER: readonly NavGroup[] = [
  "Overview",
  "Revenue",
  "Finance",
  "Operations",
  "Monitors",
  "Strategy",
  "Tools",
  "System",
] as const;

export interface FeatureNav {
  label: string;
  icon: LucideIcon;
  to: string;
  /** Permission gating the nav item. "" = visible to any authenticated user
   *  (the feature enforces per-record access on the backend instead). */
  requires: string;
  order: number;
  /** Sidebar grouping. Omit to fall under "Other" at the bottom. */
  group?: NavGroup;
}

export interface FeatureModule {
  key: string;
  nav: FeatureNav;
  /** Returns route nodes to be attached to the root route. */
  routes: (rootRoute: AnyRoute) => AnyRoute[];
}
